import { render, staticRenderFns } from "./service_index.vue?vue&type=template&id=3a6d4573&scoped=true&"
import script from "./service_index.vue?vue&type=script&lang=js&"
export * from "./service_index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6d4573",
  null
  
)

export default component.exports